import { render } from "./PainelDashMain.vue?vue&type=template&id=2be316a1&scoped=true"
import script from "./PainelDashMain.vue?vue&type=script&lang=js"
export * from "./PainelDashMain.vue?vue&type=script&lang=js"

import "./PainelDashMain.vue?vue&type=style&index=0&id=2be316a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be316a1"]])

export default __exports__